import React, { useState } from 'react'
import styled from 'styled-components'
import Filter from './Filter'
import ArticleShort from '../shared/ArticleShort'
import Pagination from './Pagination'
import buyLogo from '../../assets/buyLogo.png'
import whiteArrow from '../../assets/whiteArrow.png'
import colors from '../../styles/colors'

const StyledBuy = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`

const StyledFilter = styled(Filter)``

const StyledPagination = styled(Pagination)`
    width: auto;
`

const DropdownToggle = styled.div`
    display: flex;
    background-color: ${colors.second};
    border-radius: 15px 0 0 0;
    width: 100%;
    height: 65px;
    gap: 50px;
    justify-content: center;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    &:hover {
        filter: brightness(0.9);
    }
`

const StyledBuyLogo = styled.img`
    width: 50px;
`

const StyledDropdownToggleTitle = styled.div`
    font-size: 25px;
    color: white;
`

const StyledArrow = styled.img`
    height: 15px;
    transform: ${({ showFilter }) =>
        showFilter ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.3s ease;
`

const Buy = ({ userInfo, stuffCategories }) => {
    const [filteredResults, setFilteredResults] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [showFilter, setShowFilter] = useState(false)

    const toggleFilterVisibility = () => {
        setShowFilter((prevShowFilter) => !prevShowFilter)
    }

    return (
        <StyledBuy>
            <DropdownToggle onClick={toggleFilterVisibility}>
                <StyledBuyLogo src={buyLogo} alt="logo" />
                <StyledDropdownToggleTitle>Acheter</StyledDropdownToggleTitle>
                <StyledArrow
                    src={whiteArrow}
                    alt="arrow"
                    showFilter={showFilter}
                />
            </DropdownToggle>

            <StyledFilter
                sellOrBuySection="buy"
                userInfo={userInfo}
                setFilteredResults={setFilteredResults}
                stuffCategories={stuffCategories}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                showFilter={showFilter}
            />

            {filteredResults.results?.map((item) => (
                <ArticleShort
                    key={item._id}
                    sellOrBuySection="buy"
                    stuffCategories={stuffCategories}
                    item={item}
                />
            ))}

            <StyledPagination
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={filteredResults.pagination?.totalPages}
            />
        </StyledBuy>
    )
}

export default Buy
